module.exports = __webpack_public_path__ + "img/explore.3a0baa34.svg";